export default __webpack_public_path__ + "static/mobileLarge-24a20a9b987bddc7cc36e822c65b6bfa.jpg";